import { render, staticRenderFns } from "./SketchFabModal.vue?vue&type=template&id=8caed0c6&scoped=true&"
import script from "./SketchFabModal.vue?vue&type=script&lang=ts&"
export * from "./SketchFabModal.vue?vue&type=script&lang=ts&"
import style0 from "./SketchFabModal.vue?vue&type=style&index=0&id=8caed0c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8caed0c6",
  null
  
)

export default component.exports